export default function roomURLShareEventListener(room) {
    return store => {
        room.addEventListeners({
            room_urlshare_init: e => {
                store.commit('urlShare/SET_URLSHARE_LIST', e.data);
            },
            room_urlshare_create: e => {
                store.commit('urlShare/SET_URLSHARE', e.data.urlShareInfo);
            },
            room_urlshare_remove: e => {
                store.commit('urlShare/REMOVE_URLSHARE', e.data.urlIdx);
            },
            room_urlshare_start: e => {
                store.commit('urlShare/SET_URLSHARE_HISTORY', e);
            },
            room_urlShare_update: e => {
                store.commit('urlShare/UPDATE_URLSHARE', e.data.urlShareInfo);
            }
        });
    }
}